import { withChartLayout } from 'components/common';
import HomeMedication from 'components/features/chart/admission-history/home-medication/HomeMedication';

const HomeMedicationPage = withChartLayout('Home Medication Information')(HomeMedication);
export default HomeMedicationPage;
